import {Oauth2TokenRs} from "@QUERIES/account/useOauth2Token";
import {Response} from "@QUERIES/types";
import axios, {AxiosRequestHeaders} from "axios";

const axiosWithAccounts = axios.create({
	timeout: 7000,
	validateStatus: status => status < 500,
});

let tokenPromise: Promise<{token: string}> | null = null;

axiosWithAccounts.interceptors.response.use(async response => {
	const {config, status} = response;
	if (status === 401) {
		if (!tokenPromise) {
			tokenPromise = axios
				.post<Response<Oauth2TokenRs>>("/acct/api/account/oauth2Token")
				.then(result => {
					const token = result.data.body?.access_token || "";
					axiosWithAccounts.defaults.headers.common.Authorization = `Bearer ${token}`;
					globalThis.tokenPromise = null;
					return {token};
				})
				.finally(() => {
					tokenPromise = null;
				});
		}

		const {token} = await tokenPromise;

		// 토큰 있으면 원래 요청 재시도
		config.headers = config.headers || ({} as AxiosRequestHeaders);
		config.headers.Authorization = `Bearer ${token}`;

		if (token) {
			return axios(config);
		} else {
			return response;
		}
	}

	return response;
});

export default axiosWithAccounts;
